import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import LevellistLayer from "../components/LevelListLayer";

const CourseCategoryPage = () => {
  return (
    <>
    
        {/* Breadcrumb */}
        <div className="d-flex justify-content-between"><h5>Levels  </h5><Breadcrumb title="Levels" /></div>

        {/* AssignRoleLayer */}
        <LevellistLayer />
    </>
  );
};

export default CourseCategoryPage;
